import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from '../../../../global/services/global.service';
import { WorkspaceService } from '../../../../workspace/workspace.service';
import { JsonObjectFactoryService } from '../../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root',
})
export class GridActionModalService {
  constructor(
    private readonly jsonObjectFactory: JsonObjectFactoryService,
    private readonly gtwGlobal: GlobalService,
    private readonly gtwWorkspace: WorkspaceService,
  ) {}

  saveGridActionTemplate(baseUrl: string, actionParams: Record<string, unknown>): Observable<any> {
    const url = baseUrl.endsWith('/') ? `${baseUrl}saveGridActionTemplate` : `${baseUrl}/saveGridActionTemplate`;
    const globalAdapter = {
      globalParams: this.gtwGlobal.global?.globalParams || {},
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      getScenario: (taxYear: string) => this.gtwGlobal.getScenario(taxYear),
      inputs: (this.gtwGlobal as any).inputs,
    };
    return this.jsonObjectFactory.saveJSONWParams(url, actionParams, globalAdapter);
  }
}
